import styled, { css } from 'styled-components'

export const Td = styled.td<{
  $cornerTopLeft?: boolean
  $cornerTopRight?: boolean
  $cornerBottomLeft?: boolean
  $cornerBottomRight?: boolean
}>`
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  min-width: 36px;

  ${({ $cornerTopLeft }) =>
    $cornerTopLeft &&
    css`
      border-top-left-radius: 1rem;
    `};

  ${({ $cornerTopRight }) =>
    $cornerTopRight &&
    css`
      border-top-right-radius: 1rem;
    `};

  ${({ $cornerBottomLeft }) =>
    $cornerBottomLeft &&
    css`
      border-bottom-left-radius: 1rem;
    `};

  ${({ $cornerBottomRight }) =>
    $cornerBottomRight &&
    css`
      border-bottom-right-radius: 1rem;
    `};
`

export const Table = styled.table<{ $withGrid?: boolean }>`
  border-collapse: collapse;
  ${({ $withGrid, theme }) =>
    $withGrid &&
    css`
      tbody tr:nth-child(1) td {
        border-bottom: 1px solid ${theme.colors.greyFields};
      }

      tbody tr td:not(:last-child) {
        border-right: 1px solid ${theme.colors.greyFields};
      }

      tbody td {
        background-color: ${({ theme }) => theme.colors.blueBack};
      }
    `};
`
export const Th = styled.th``
export const Thead = styled.thead`
  ${Th} {
    ${({ theme }) => theme.textStyles.firaSansTextBaseSemiBold};
    color: ${({ theme }) => theme.colors.bluePrimary};
    padding-bottom: 1.5rem;
  }
  th:first-child {
    opacity: 0;
  }
`
export const Tbody = styled.tbody`
  ${Th} {
    ${({ theme }) => theme.textStyles.firaSansTextBase};
    color: ${({ theme }) => theme.colors.blueSecondaryBis};
    padding-right: 3rem;
    text-align: left;
  }

  tr:first-child {
    td {
      padding-top: 1.6rem;
      &:first-of-type {
        padding-left: 1.6rem;
      }
      &:last-of-type {
        padding-right: 1.6rem;
      }
    }
  }
  tr:last-child {
    td {
      padding-bottom: 1.6rem;
      &:first-of-type {
        padding-left: 1.6rem;
      }
      &:last-of-type {
        padding-right: 1.6rem;
      }
    }
  }
`
export const Tr = styled.tr``
export const Content = styled.span``
